module.exports = __webpack_public_path__ + "static/media/ICT-6.9918818c.png";